// removed by extract-text-webpack-plugin
module.exports = {"image-frame":"image-frame","image-wrapper":"image-wrapper","image-container":"image-container"};


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/demoContent_style.css
// module id = 151
// module chunks = 0